import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { BodyPrimary, BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
    activateTwoStepAuthentication,
    deactivateTwoStepAuthentication,
} from '@/redux/modules/account/twoStepAuthentication/twoStepAuthentication.actions';
import { getTwoStepAuthenticationActivated } from '@/redux/modules/account/twoStepAuthentication/twoStepAuthentication.selectors';
import { getBidderId } from '@/redux/modules/account/user/user.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import TwoStepAuthenticationActivationModal from './components/ActivationModal/TwoStepAuthenticationActivationModal';
import TwoStepAuthenticationDeactivationModal from './components/DeactivationModal/TwoStepAuthenticationDeactivationModal';

export const TwoStepAuthentication = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();
    const bidderId = useAppSelector(getBidderId);
    const hasTwoStepActive = useAppSelector(getTwoStepAuthenticationActivated);
    const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);
    const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);

    const openModal = () => {
        if (hasTwoStepActive) {
            setIsDeactivateModalOpen(true);
        } else {
            setIsActivateModalOpen(true);
        }
    };

    const onCloseModal = () => {
        setIsActivateModalOpen(false);
        setIsDeactivateModalOpen(false);
    };

    return (
        <article>
            <TwoStepAuthenticationActivationModal
                onActivate={() => {
                    dispatch(activateTwoStepAuthentication({ bidderId }));
                    onCloseModal();
                }}
                onCancel={onCloseModal}
                show={isActivateModalOpen}
            />
            <TwoStepAuthenticationDeactivationModal
                onCancel={onCloseModal}
                onDeactivate={() => {
                    dispatch(deactivateTwoStepAuthentication(bidderId));
                    onCloseModal();
                }}
                show={isDeactivateModalOpen}
            />
            <header className="mb-xs">
                <BodyPrimary>
                    {formatMessage(['accountSettings', 'security', 'twoStepAuthentication', 'header'])}
                </BodyPrimary>
                <BodySecondary className={cn('ml-xs', hasTwoStepActive ? 'text-text-success' : 'text-text-inactive')}>
                    {formatMessage([
                        'accountSettings',
                        'security',
                        'twoStepAuthentication',
                        hasTwoStepActive ? 'active' : 'inactive',
                    ])}
                </BodySecondary>
            </header>
            <p className="mb-lg">
                <BodySecondary color="secondary">
                    {formatMessage(['accountSettings', 'security', 'twoStepAuthentication', 'description'])}
                </BodySecondary>
            </p>
            <Button
                className="max-[500px]:w-full w-[194px]"
                onClick={openModal}
                variant={hasTwoStepActive ? 'outlined' : 'filled'}
            >
                {formatMessage([
                    'accountSettings',
                    'security',
                    'twoStepAuthentication',
                    hasTwoStepActive ? 'deactivate' : 'activate',
                ])}
            </Button>
        </article>
    );
};

export default TwoStepAuthentication;
